import { useTranslation } from 'react-i18next'

export const usePermissionMessage = (): string => {
    const { t } = useTranslation(['common'])

    return t(
        'common:permissions.generic',
        'You do not have permission to perform this action.'
    )
}
